var map = {
	"../pages/color-picker-pop/color-picker-pop.module": [
		500,
		2
	],
	"../pages/crm/crm.module": [
		193
	],
	"../pages/dashboard/dashboard.module": [
		501,
		1
	],
	"../pages/download-modal/download-modal.module": [
		319
	],
	"../pages/home/home.module": [
		320
	],
	"../pages/login/login.module": [
		321
	],
	"../pages/order-manager/order-manager.module": [
		502,
		0
	],
	"../pages/orders/orders.module": [
		323
	],
	"../pages/partners/partners.module": [
		503,
		4
	],
	"../pages/specs-modal/specs-modal.module": [
		504,
		3
	],
	"../pages/stream/stream.module": [
		327
	],
	"../pages/trans-rejection/trans-rejection.module": [
		328
	],
	"../pages/trans/trans.module": [
		329
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 187;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 187
// module chunks = 5